import * as type from '../ActionTypes';

const initialState = {
  skillLoading: false,
  skillExperienceData: {},
  skillsError: null,
  skillExperienceStatus: false
};

export default function SkillExperienceReducer(state = initialState, action: any) {
  switch (action.type) {
    case type.SAVE_SKILL_REQUEST:
      return {
        ...state,
        skillLoading: true,
        skillsError: null
      };
    case type.SAVE_SKILL_SUCCESS:
      return {
        ...state,
        skillLoading: false,
        skillsError: null
      };
    case type.SAVE_SKILL_FAILURE:
      return {
        ...state,
        skillLoading: false,
        skillsError: action.error
      };
    case type.SAVE_SKILL_EXPERIENCE_REQUEST:
      return {
        ...state,
        skillLoading: true,
        skillsError: null,
        skillExperienceStatus: false
      };
    case type.SAVE_SKILL_EXPERIENCE_SUCESS:
      return {
        ...state,
        skillLoading: true,
        skillExperienceData: action.data,
        skillExperienceStatus: true
      };
    case type.SAVE_SKILL_EXPERIENCE_FAILURE:
      return {
        ...state,
        skillLoading: false,
        skillsError: action.error,
        skillExperienceStatus: false
      };
    case type.UPDATE_SKILL_EXPERIENCE_REQUEST:
      return {
        ...state,
        skillLoading: true,
        skillsError: null
      };
    case type.RESET_SKILL_EXPERIENCE:
      return {
        ...state,
        skillLoading: false,
        skillsError: null,
        skillExperienceStatus: false
      };
    case type.RESET_REGISTER_USER:
      return {
        ...initialState
      };
    default:
      return state;
  }
}
